var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 84,
    viewBox: "0 0 250 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_134_4444)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.9425,
    y: 5,
    width: 230.115,
    height: 64.1584,
    rx: 12.8317,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3719,
    y: 5.42937,
    width: 229.256,
    height: 63.2997,
    rx: 12.4023,
    stroke: "url(#paint0_linear_134_4444)",
    strokeWidth: 0.858736
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5882,
    cy: 37.0792,
    r: 19.2475,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2336,
    y: 24.2476,
    width: 145.426,
    height: 9.4099,
    rx: 3.42178,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2336,
    y: 40.501,
    width: 145.426,
    height: 9.4099,
    rx: 3.42178,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.0399,
    y: 25.5292,
    width: 23.097,
    height: 23.097,
    rx: 11.5485,
    fill: "#005EB8",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3267 37.603L42.1385 42.4149L51.7623 32.7911",
    stroke: "#005EB8",
    strokeWidth: 1.92475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_134_4444",
    x: 0.496408,
    y: 0.70632,
    width: 249.007,
    height: 83.0506,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.858736,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_134_4444"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15242
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_134_4444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_134_4444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_4444",
    x1: 125,
    y1: 5,
    x2: 125,
    y2: 69.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentCard1);
export default __webpack_public_path__ + "static/media/AssessmentCard1.1dcd8225ee41341a370c3115cbb5ff5c.svg";
export { ForwardRef as ReactComponent };